var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup805(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_805",
    "data-name": "Group 805",
    transform: "translate(-80 -604)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    transform: "translate(80 604)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kalyan_logo",
    transform: "translate(244.671 278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3940",
    "data-name": "Path 3940",
    d: "M-139.631,372.578-144,382.125c0,10.841,21.2,10.841,23.948,10.841h0c2.751,0,9.709,1.052,9.709,1.052-1.942-18.366-17.314-26.618-17.314-26.618Z",
    transform: "translate(0 -5.518)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3941",
    "data-name": "Path 3941",
    d: "M-143.9,350.717v26.861a13.66,13.66,0,0,1,6.068-5.906h0c7.2-3.56,25.566-12.3,27.508-33.172,0,0-7.362,1.295-11.246,1.942h0C-125.292,341.008-143.819,341.17-143.9,350.717Z",
    transform: "translate(-0.019 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup805);
export default __webpack_public_path__ + "static/media/Group 805.2ef91c2f4457408048bd895a1764e4d4.svg";
export { ForwardRef as ReactComponent };